import React, { useEffect, useState } from "react";
import {
  Container,
  Box,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  Stack,
  Avatar,
  Paper,
} from "@mui/material";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { getBlogById, getRelatedBlogs, getAllCategories } from "../services/Apis";

// Simulated API data (replace with fetch in real app)


const Catogoryblog = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlog = async () => {
      const blogData = await getBlogById(id);
      setBlog(blogData);
    };
    fetchBlog();
  }, [id]);

  useEffect(() => {
    if (!id) return;
    const fetchRelated = async () => {
      const relBlogs = await getRelatedBlogs(id);
      setRelatedBlogs(relBlogs);
    };
    fetchRelated();
  }, [id]);

  useEffect(() => {
    const fetchCategories = async () => {
      const cats = await getAllCategories();
      setCategories(cats);
    };
    fetchCategories();
  }, []);

  if (!blog) return null;

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>

      <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: { xs: 2, md: 4 }, }}>
        {/* Main Blog Content */}
        <Box sx={{ flex: 2, minWidth: 0, width: { xs: '100%', md: 'auto' }, mb: { xs: 3, md: 0 }, }}>
          <Typography variant="h6" fontWeight={500} mb={2} sx={{ fontFamily: "Poppins", fontSize: { xs: '20px', sm: '22px', md: '24px', display: 'inline' } }}>
            Blog
          </Typography>
          <Paper elevation={0} sx={{ borderRadius: 2, overflow: "hidden", mb: 2 }}>
            <Box component="img" src={blog.imageUrl} alt="blog" sx={{ width: "100%", height: { xs: 160, sm: 200, md: 260 }, objectFit: "cover", borderRadius: 2 }} />
          </Paper>
          <Stack direction={{ xs: "column", sm: "row" }} alignItems={{ xs: "flex-start", sm: "center" }} width="100%" justifyContent="space-between" spacing={2} mb={1} sx={{ flexWrap: { xs: "wrap", sm: "nowrap" }, gap: { xs: 1, sm: 2 } }}>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Box display="flex" alignItems="center" gap={1}>
                <i className="fa-regular fa-calendar" style={{ color: "#CB4422", fontSize: 14 }} />
                <Typography sx={{ fontSize: 13, color: "#CB4422" }}>
                  {new Date(blog.createdAt).toLocaleDateString()}
                </Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <i className="fa-regular fa-clock" style={{ color: "#CB4422", fontSize: 14 }} />
                <Typography sx={{ fontSize: 13, color: "#CB4422" }}>
                  {new Date(blog.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                </Typography>
              </Box>
            </Box>
            <Box display="flex" alignItems="center" gap={1} sx={{ ml: { xs: 0, sm: "auto" }, mt: { xs: 1, sm: 0 }, alignSelf: { xs: "flex-start", sm: "center" } }}>
              <i className="fa-regular fa-user" style={{ color: "#CB4422", fontSize: 14 }} />
              <Typography sx={{ fontSize: 13, color: "#000" }}>
                Author/Writer: {blog.name}
              </Typography>
            </Box>
          </Stack>
          <Typography variant="h5" fontWeight={600} mb={1} sx={{ fontFamily: "Poppins", fontSize: { xs: '18px', sm: '20px', md: '24px' } }}>
            {blog.title}
          </Typography>
          <Typography sx={{ color: "#222", fontSize: { xs: 14, sm: 15 }, mb: 2, textAlign: "justify" }}>
            <span dangerouslySetInnerHTML={{ __html: blog.content }} />
          </Typography>
          {Array.isArray(blog.list) && blog.list.length > 0 && (
            <List disablePadding sx={{ pl: 0, mb: 2 }}>
              {blog.list.map((item, idx) => (
                <ListItem disablePadding sx={{ display: "list-item", py: 0 }} key={idx}>
                  <ListItemText
                    primary={
                      <Typography sx={{ fontSize: { xs: 13, sm: 14 } }}>
                        {item}
                      </Typography>
                    }
                  />
                </ListItem>
              ))}
            </List>
          )}
        </Box>

        {/* Sidebar */}
        <Box sx={{ display: { xs: "block", md: "block" }, minWidth: { xs: '100%', md: 160 }, maxWidth: { xs: '100%', md: 280 }, top: 0, position: { xs: "static", md: "relative" }, }}>
          {/* Categories */}


          {/* Recent Posts */}
          <Typography variant="h6" fontWeight={500} mb={1} sx={{ fontFamily: "Poppins", fontSize: { xs: '17px', sm: '18px', md: '20px' } }}>
            Recent Posts
          </Typography>
          <Divider sx={{ mb: 1 }} />
          <List dense sx={{ mb: 3 }}>
            {relatedBlogs.map((post) => (
              <ListItem onClick={() => navigate(`/category-blog/${post.id}`)} key={post.id} alignItems="flex-start" sx={{ py: 1, cursor: "pointer" }}>
                <Avatar src={post.imageUrl} alt={post.title} sx={{ width: { xs: 60, sm: 90, md: 116 }, height: { xs: 40, sm: 60, md: 76 }, mr: 1.5, borderRadius: 1 }} variant="rounded" />
                <Box>
                  <Typography sx={{ fontSize: { xs: '12px', sm: '13px' }, fontWeight: 500, color: "#222" }}>{post.title}</Typography>
                  <Box display="flex" alignItems="center" gap={1} mt={0.5}>
                    <i className="fa-regular fa-calendar" style={{ color: "#CB4422", fontSize: 13 }} />
                    <Typography sx={{ fontSize: 12, color: "#CB4422" }}>{new Date(post.createdAt).toLocaleDateString()}</Typography>
                  </Box>
                </Box>
              </ListItem>
            ))}
          </List>

          {/* Archives */}

        </Box>
      </Box>
    </Container>
  );
};

export default Catogoryblog;